import { useEffect, useState } from "react";
import {
  CATEGORIES,
  POPULAR_CATEGORIES,
} from "constants/navigation/categories";
import { cacheImages } from "helpers/cacheImages";
import CoverGloryGame from "assets/images/glory/cover_game.webp";
import CoverBangerGame from "assets/images/banger/cover-banger.webp";
import { useCatalogsStore } from "stores/catalogs";
import { getInitLanguage } from "helpers/language";
import { useCurrenciesData } from "queries/useCurrenciesData";
import { useLanguagesData } from "queries/useLanguagesData";
import { useLocalizationData } from "queries/useLocalizationData";
import { useCountryData } from "queries/useCountryData";
import { useLocalizationStore } from "stores/localization";

const initStatuses = {
  images: false,
  currencies: false,
  languages: false,
  localization: false,
};

export const useInitLoading = () => {
  const [statuses, setStatuses] = useState(initStatuses);
  const appLang = getInitLanguage();

  const { isCurrenciesLoaded, isLanguagesLoaded, isLocalizationLoaded } =
    useCatalogsStore((state) => ({
      isCurrenciesLoaded: state.isCurrenciesLoaded,
      isLanguagesLoaded: state.isLanguagesLoaded,
      isLocalizationLoaded: state.isLocalizationLoaded,
    }));
  const changeLanguage = useLocalizationStore((state) => state.changeLanguage);

  useCurrenciesData();
  useLanguagesData();
  useLocalizationData(appLang);
  useCountryData();

  useEffect(() => {
    if (isCurrenciesLoaded) {
      setStatuses((prev) => ({ ...prev, currencies: true }));
    }
    if (isLanguagesLoaded) {
      setStatuses((prev) => ({ ...prev, languages: true }));
    }
    if (isLocalizationLoaded) {
      setStatuses((prev) => ({ ...prev, localization: true }));
    }
  }, [isCurrenciesLoaded, isLanguagesLoaded, isLocalizationLoaded]);

  useEffect(() => {
    changeLanguage(appLang.toUpperCase());
  }, [changeLanguage, appLang]);

  useEffect(() => {
    const categoryImages = [...POPULAR_CATEGORIES, ...CATEGORIES].map(
      (cat) => cat.image,
    );

    const loadImages = () => {
      cacheImages([CoverGloryGame, CoverBangerGame, ...categoryImages])
        .then(() => {
          setStatuses((prev) => ({
            ...prev,
            images: true,
          }));
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error caching images:", error);
        });
    };

    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadImages);
    } else {
      loadImages(); // Фоллбек, если `requestIdleCallback` не поддерживается
    }
  }, []);

  return {
    progress: Object.values(statuses).filter((status) => status).length,
    total: Object.values(statuses).length,
  };
};
